import { Box, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import { routes } from "../../constants/routes";
import { colors } from "../../theme/colors";
import { ButtonSize, ButtonVariant } from "./Button";
import NavButton from "./NavButton";

const NavigationPanel = ({
  mobile,
  variant = "header",
  setMobileNavOpen
}: {
  mobile?: boolean;
  variant?: "header" | "footer";
  setMobileNavOpen?: () => void;
}) => {
  const location = useLocation();
  const theme = useTheme();
  const { t } = useTranslation();

  const navigationOptions: { route: string; label: string }[] = [
    { route: routes.home, label: t("buttons.home") },
    { route: routes.products, label: t("buttons.products") },
    { route: routes.certificates, label: t("buttons.certificates") },
    { route: routes.contact, label: t("buttons.contact") }
  ];

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: mobile || variant === "footer" ? "column" : "row",
        gap: 2
      }}>
      {navigationOptions.map((option) => (
        <NavButton
          key={option.label}
          onClick={setMobileNavOpen}
          route={option.route}
          label={option.label}
          variant={mobile ? ButtonVariant.secondary : ButtonVariant.accent}
          size={mobile ? ButtonSize.full : ButtonSize.auto}
          isActive={location.pathname === option.route}
          activeStyle={
            mobile
              ? undefined
              : {
                  color: colors.green,
                  backgroundColor: "transparent",
                  border: `3px solid ${colors.green}`
                }
          }
          sx={{
            width: variant === "footer" ? theme.spacing(40) : mobile ? "100%" : "auto"
          }}
        />
      ))}
    </Box>
  );
};

export default NavigationPanel;
